import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../components/PageHero';
export function Contact() {
  return <>
      <PageHero eyebrow="CONTACT" headline="Start the conversation" data-id="element-242" />

      <section className="bg-sure-black w-full py-24 md:py-32 min-h-[60vh]" data-id="element-243">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-244">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="max-w-3xl mb-16 md:mb-24" data-id="element-245">
            <p className="text-sure-gray text-lg md:text-xl font-light leading-relaxed" data-id="element-246">
              If you are exploring how to improve visibility, performance and
              decision-making across your network, we would welcome a discussion
              around your priorities and how decision-grade passenger
              intelligence can support them.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-247">
            {/* Left Column: CTAs */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="flex flex-col space-y-6" data-id="element-248">
              <a href="mailto:sales@sure-ai.tech?subject=Request%20a%20Briefing" className="w-full px-8 py-6 bg-sure-white text-sure-black text-sm uppercase tracking-widest font-medium hover:scale-[1.02] hover:bg-gray-100 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sure-accent focus:ring-offset-2 focus:ring-offset-sure-black text-center" data-id="element-249">
                Request a Briefing
              </a>

              <a href="mailto:sales@sure-ai.tech?subject=Arrange%20a%20Demonstration" className="w-full px-8 py-6 border border-sure-white text-sure-white text-sm uppercase tracking-widest font-medium hover:bg-sure-white hover:text-sure-black transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sure-accent focus:ring-offset-2 focus:ring-offset-sure-black text-center" data-id="element-250">
                Arrange a Demonstration
              </a>

              <a href="mailto:sales@sure-ai.tech?subject=General%20Enquiry" className="w-full px-8 py-6 border border-sure-white text-sure-white text-sm uppercase tracking-widest font-medium hover:bg-sure-white hover:text-sure-black transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sure-accent focus:ring-offset-2 focus:ring-offset-sure-black text-center" data-id="element-251">
                General Enquiry
              </a>
            </motion.div>

            {/* Right Column: Contact Info */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} className="flex flex-col justify-center space-y-12" data-id="element-252">
              <div data-id="element-253">
                <h3 className="text-sure-accent text-xs uppercase tracking-widest font-medium mb-4" data-id="element-254">
                  Email
                </h3>
                <a href="mailto:sales@sure-ai.tech" className="text-sure-white text-xl md:text-2xl font-light hover:text-sure-accent transition-colors duration-300" data-id="element-255">
                  sales@sure-ai.tech
                </a>
              </div>

              <div data-id="element-256">
                <h3 className="text-sure-accent text-xs uppercase tracking-widest font-medium mb-4" data-id="element-257">
                  London Office
                </h3>
                <div className="text-sure-gray text-base md:text-lg font-light leading-relaxed" data-id="element-258">
                  <p data-id="element-259">71-75 Shelton Street</p>
                  <p data-id="element-260">Covent Garden, London</p>
                  <p data-id="element-261">WC2H 9JQ, United Kingdom</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>;
}